export default __webpack_public_path__ + "clock.18c716ea542bd7728dab9116edc0b1c3.svg";